import { render, staticRenderFns } from "./SerailNoQrPrintComponent.vue?vue&type=template&id=0896f074&"
import script from "./SerailNoQrPrintComponent.vue?vue&type=script&lang=js&"
export * from "./SerailNoQrPrintComponent.vue?vue&type=script&lang=js&"
import style0 from "./SerailNoQrPrintComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
